<lib-lib-mon-profil [configuration]="configuration" (onUpdateFullName)="handleUpdateFullName($event)" [config_global]="config_global"
                    [fileNamePattern] = fileNamePattern></lib-lib-mon-profil>
